import React, { PureComponent, Component } from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import openSocket from 'socket.io-client';

// import matchSorter from 'match-sorter';

// const data = require('../DataSource/testTrips.json').TRIPS;

/* const socket = openSocket('http://192.168.38.245:8000');
socket.on('finish', function (data) {
    console.log('Caught Event "finish" after calling cmd, data: ' + data);
}); */

let state = {
    filterTripTxt: '',
    filterBeginTimeTxt: 'all',
    filterEndTimeTxt: 'all'
};

class SchedulesTable extends Component {
    constructor() {
        super();
        this.state = state;
    }

    componentWillUnmount() {
        // Remember state for the next mount
        state = this.state;
    }

    handleBtnClkAll(e){
        console.log("Run All");
        // socket.emit("-b", "PENQUIS", "ALL", "");
    }

    run(row){
        console.log(row);
    }

    render() {
        const columns = [{
            Header: '',
            id: 'sorder',
            accessor: 'sorder',
            maxWidth: 30
        }, {
            Header: 'Mobility',
            id: 'mobility_list',
            accessor: 'mobility_list',
            maxWidth: 66
        }, {
            Header: 'Operator',
            id: 'oper_id',
            accessor: 'oper_id',
            maxWidth: 88
        }, {
            Header: 'Region',
            id: 'region',
            accessor: 'region',
            maxWidth: 100
        }, {
            Header: 'SZone',
            id: 'szone',
            accessor: 'szone',
            maxWidth: 100
        }, {
            Header: 'Route Type',
            id: 'route_type',
            accessor: 'route_type',
            maxWidth: 88
        }, {
            Header: 'Run',
            id: 'run_btn',
            Cell: row => (
                <button >Run</button>
            ),
            Footer: (
                <button onClick={(e) => this.handleBtnClkAll(e)}>Run All</button>
            ),
            maxWidth: 76
        }, {
            Header: 'Stats',
            id: 'stats_1',
            accessor: 'stats_1',
            maxWidth: 100
        }, {
            Header: 'Stats',
            id: 'stats_2',
            accessor: 'stats_2',
            maxWidth: 100
        }
        ];
        return (
            <ReactTable
                // data={data}
                data={this.props.data}
                columns={columns}
                style={{
                    height: "286px", // This will force the table body to overflow and scroll, since there is not enough room
                    width: "750px"
                }}
                // defaultPageSize={100}
                defaultPageSize={-1}
                showPagination={false}
            />
        );
    }
}

export default SchedulesTable;



// WEBPACK FOOTER //
// ./src/Componets/SchedulesTable.js